import { combineReducers } from "redux";

import { UPDATE_ORDERING_INFO } from "actions/online_ordering";

import cart from "reducers/online_ordering/cart";
import authentication from "reducers/authentication";
import orderingOptions from "reducers/online_ordering/ordering_options";
import checkout from "reducers/online_ordering/checkout";
import consumer from "reducers/online_ordering/consumer";
import publishStatus from "reducers/online_ordering/publish_status";
import deliveryAddress from "reducers/online_ordering/delivery_address";
import storeInfo from "reducers/online_ordering/store_info";

const initialState = {
  menu: null,
  deliveryTaxRate: null,
  stockLevels: null,
};

function orderingInfo(state = initialState, action) {
  switch (action.type) {
    case UPDATE_ORDERING_INFO: {
      return {
        ...state,
        menu: action.orderingInfo.menu,
        deliveryTaxRate: action.orderingInfo.deliveryTaxRate,
        stockLevels: action.orderingInfo.stockLevels,
      };
    }

    default:
      return state;
  }
}

const reducers = combineReducers({
  authentication,
  cart,
  checkout,
  consumer,
  deliveryAddress,
  orderingInfo,
  orderingOptions,
  publishStatus,
  storeInfo,
});

export default reducers;
